import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ParkingZoneService } from '../../../api/gen/api/parkingZone.service';
import { ParkingZoneDto } from '../../../api/gen/model/parkingZoneDto';
import { ParkingSpaceService } from '../../../api/gen';
import { JJamesAlertComponent, JJamesCardComponent, JjamesButtonComponent } from 'shared-lib';
@Component({
  selector: 'app-unassign-parking-zone',
  imports: [
    CommonModule,
    JjamesButtonComponent,
    JJamesCardComponent,
    JJamesAlertComponent
  ],
  templateUrl: './unassign-parking-zone.component.html',
  styleUrl: './unassign-parking-zone.component.scss'
})
export class UnassignParkingZoneComponent implements OnInit {
  isUnassigning = false;
  isLoading = true;
  errorMessage: string | null = null;
  successMessage: string | null = null;
  zoneId: string | null = null;
  parkingSpaceId: string | null = null;
  currentZone: ParkingZoneDto | null = null;

  constructor(
    private parkingZoneService: ParkingZoneService,
    private parkingSpaceService: ParkingSpaceService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.zoneId = this.route.snapshot.paramMap.get('zoneId');
    this.parkingSpaceId = this.route.snapshot.paramMap.get('parkingSpaceId');

    if (this.zoneId && this.parkingSpaceId) {
      this.loadZone();
    } else {
      this.router.navigate(['/parking-spaces']);
    }
  }

  private loadZone(): void {
    if (!this.zoneId) return;

    this.isLoading = true;
    this.parkingZoneService.parkingZoneParkingZoneIdGet(this.zoneId).subscribe({
      next: (response: any) => {
        this.currentZone = response;
        this.isLoading = false;
      },
      error: (error: any) => {
        this.errorMessage = 'Failed to load parking zone details' + error.error;
        this.isLoading = false;
        console.error('Error loading zone:', error);
      }
    });
  }

  onConfirmUnassign(): void {
    if (!this.zoneId || !this.parkingSpaceId) return;

    this.isUnassigning = true;
    this.errorMessage = null;

    this.parkingSpaceService.parkingSpaceParkingSpaceIdRemoveParkingZoneParkingZoneIdPost(this.parkingSpaceId, this.zoneId).subscribe({
      next: (response) => {
        if (response) {
          this.successMessage = 'Parking zone unassigned successfully!';
          this.isUnassigning = false;
          // Navigate back after a short delay to show success message
          setTimeout(() => {
            this.onCancel();
          }, 2000);
        }
      },
      error: (error: any) => {
        this.errorMessage = 'Failed to unassign parking zone. Please try again.';
        this.isUnassigning = false;
        console.error('Error unassigning zone:', error);
      }
    });
  }

  onCancel(): void {
    this.router.navigate(['/parking-spaces']);
  }

  getZoneAddressString(): string {
    if (!this.currentZone?.address) return 'No address specified';

    const address = this.currentZone.address;
    const parts = [
      address.firstAddressLine,
      address.secondAddressLine,
      address.locality,
      address.postCode,
      address.region
    ].filter(part => part && part.trim());

    return parts.length > 0 ? parts.join(', ') : 'No address specified';
  }
}
